import { Component } from '@angular/core';

@Component({
    selector: 'app-semanal',
    templateUrl: './semanal.component.html',
    styleUrl: './semanal.component.css',
    standalone: false
})
export class SemanalComponent {

}
